import { render, staticRenderFns } from "./WhatsappV3WarningBanner.vue?vue&type=template&id=7bfa3dde&scoped=true"
import script from "./WhatsappV3WarningBanner.vue?vue&type=script&lang=js"
export * from "./WhatsappV3WarningBanner.vue?vue&type=script&lang=js"
import style0 from "./WhatsappV3WarningBanner.vue?vue&type=style&index=0&id=7bfa3dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfa3dde",
  null
  
)

export default component.exports